import {useAuthStore} from '@/stores/auth.store'
import {Role} from '@wonder/entities'

export const isRole = (role: Role) => useAuthStore().authSession.roles.includes(role)
